module.exports = __webpack_public_path__ + "static/media/art71.33b48dcb.jpg";